// store/index.js
export const state = () => ({
  // Central state if needed
});

export const mutations = {
  // Central mutations if needed
};

export const actions = {
  // Central actions if needed
};
